var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.76 4.57333L20.88 6.45333C22.8 8.38666 24 11.0533 24 14C24 19.8933 19.2267 24.6667 13.3333 24.6667C7.44 24.6667 2.66667 19.8933 2.66667 14C2.66667 8.56 6.73333 4.08 12 3.42666V6.12C8.21333 6.76 5.33333 10.04 5.33333 14C5.33333 18.4133 8.92 22 13.3333 22C17.7467 22 21.3333 18.4133 21.3333 14C21.3333 11.7867 20.44 9.78666 18.9867 8.34666L17.1067 10.2267C18.0667 11.2 18.6667 12.5333 18.6667 14C18.6667 16.9467 16.28 19.3333 13.3333 19.3333C10.3867 19.3333 8 16.9467 8 14C8 11.52 9.70667 9.45333 12 8.85333V11.7067C11.2 12.1733 10.6667 13.0133 10.6667 14C10.6667 15.4667 11.8667 16.6667 13.3333 16.6667C14.8 16.6667 16 15.4667 16 14C16 13.0133 15.4667 12.16 14.6667 11.7067V0.666664H13.3333C5.97333 0.666664 0 6.64 0 14C0 21.36 5.97333 27.3333 13.3333 27.3333C20.6933 27.3333 26.6667 21.36 26.6667 14C26.6667 10.32 25.1733 6.98666 22.76 4.57333Z",
    fill: "#B8D8E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsIcon);
export default __webpack_public_path__ + "static/media/teamsIcon.3ac6bf41206a36af741fbceda00f60dc.svg";
export { ForwardRef as ReactComponent };